import { createContext, useContext, useState, useCallback } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const MIN_SEARCH_LENGTH = 2;
const ACSearchInputContext = /*#__PURE__*/createContext(undefined);
export const ACSearchInputProvider = ({
  children
}) => {
  const [searchValue, setSearchValue] = useState('');
  const [suggestions, setSuggestions] = useState(undefined);
  const [isAutocompleteSuggestionSelected, setIsAutocompleteSuggestionSelected] = useState(false);
  const handleSearchValueChange = useCallback(newSearchValue => {
    setSearchValue(newSearchValue);
    if (newSearchValue.length < MIN_SEARCH_LENGTH) {
      setSuggestions(undefined);
    }
  }, []);
  const value = {
    searchValue,
    suggestions,
    isAutocompleteSuggestionSelected,
    setIsAutocompleteSuggestionSelected,
    setSuggestions,
    handleSearchValueChange
  };
  return /*#__PURE__*/_jsx(ACSearchInputContext.Provider, {
    value: value,
    children: children
  });
};
export const useACSearchInputContext = () => {
  const context = useContext(ACSearchInputContext);
  if (context === undefined) {
    throw new Error('useACSearchInputContext must be used within an ACSearchInputProvider');
  }
  return context;
};